import { getAssetPath } from "../../utils";
import ProcessorWrapper from "./ProcessorWrapper";
import { TFLiteTransformer } from "./transformers/TFLiteTransformer";
export * from "./transformers/types";

export { ProcessorWrapper };

export const BackgroundBlur = async (blurRadius: number = 100, targetFps?: number | null) => {
  const transformer = new TFLiteTransformer({
    assetsPath: getAssetPath(),
    blurFilterRadius: blurRadius,
  });
  await transformer.loadModel();
  return new ProcessorWrapper({ transformer, name: "background-blur", targetFps: targetFps || undefined });
};

export const VirtualBackground = async (imagePath: string, targetFps?: number | null) => {
  const image = new Image();
  image.crossOrigin = "anonymous";
  image.src = imagePath;
  await new Promise((resolve) => {
    image.onload = resolve;
  });
  const transformer = new TFLiteTransformer({
    assetsPath: getAssetPath(),
    backgroundImage: image,
  });
  await transformer.loadModel();
  return new ProcessorWrapper({ transformer, name: "virtual-background", targetFps: targetFps || undefined });
};
